exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".email-wrap[data-v-4c0e0a12]{position:relative;width:100%}.email-wrap input[data-v-4c0e0a12],.email-wrap div[data-v-4c0e0a12]{-webkit-tap-highlight-color:rgba(0,0,0,0);outline:none;border:0}.email-wrap .memail-inner[data-v-4c0e0a12]{position:relative;width:100%}\n", ""]);

